import { render, staticRenderFns } from "./channelOrderDetail.vue?vue&type=template&id=2182ce8d&scoped=true"
import script from "./channelOrderDetail.vue?vue&type=script&lang=js"
export * from "./channelOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./channelOrderDetail.vue?vue&type=style&index=0&id=2182ce8d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2182ce8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2182ce8d')) {
      api.createRecord('2182ce8d', component.options)
    } else {
      api.reload('2182ce8d', component.options)
    }
    module.hot.accept("./channelOrderDetail.vue?vue&type=template&id=2182ce8d&scoped=true", function () {
      api.rerender('2182ce8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/channelOrderDetail.vue"
export default component.exports